import React from 'react'
import PropTypes from 'prop-types'

export function Electricity({
  size = '1.125rem',
  colour = 'currentColor',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="-3 0 20 18"
      {...props}
      style={{ width: size, height: size }}
    >
      <g fill={colour} fillRule="evenodd">
        <path d="M9.24089 0.841688L0.607553 8.57502C0.07422 9.05835 0.37422 9.95002 1.09089 10.0167L7.83255 10.6667L3.79089 16.3C3.60755 16.5584 3.63255 16.9167 3.85755 17.1417C4.10755 17.3917 4.49922 17.4 4.75755 17.1584L13.3909 9.42502C13.9242 8.94169 13.6242 8.05002 12.9076 7.98335L6.16589 7.33335L10.2076 1.70002C10.3909 1.44169 10.3659 1.08335 10.1409 0.858355C9.89089 0.608355 9.49922 0.600022 9.24089 0.841688Z" />
      </g>
    </svg>
  )
}

Electricity.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
